import type { TypePolicies } from '@apollo/client';
import { upperFirst } from 'lodash';

export const Query: TypePolicies['Query'] = {
  fields: {
    interaction: {
      read(_, { args, toReference }) {
        return toReference({
          __typename: upperFirst(args?.input?.type),
          id: args?.input?.id,
        });
      },
    },
  },
};
